import wingoChat from '@web/assets/wingo-chat.png'
import React from 'react'
import { serverMaintenanceVariants } from '../styles'

const { container, forAnyQuestionOpen, maintenanceUnderProgress, serverUnderMaintenance } = serverMaintenanceVariants()

const ServerMaintenance = () => (
  <div className={container()}>
    <img
      src={wingoChat}
      alt='WingoChat'
    />
    <div className='flex flex-col items-center font-bold text-secondary-medium'>
      <p className={serverUnderMaintenance()}>Atualização em curso</p>
      <p className={maintenanceUnderProgress()}>
        Estamos realizando uma atualização na aplicação. Por favor, volte novamente em instantes.
      </p>
      <div className={forAnyQuestionOpen()}>
        <p>
          Em caso de dúvidas, por favor, abra um <></>
          <a
            href='https://helpdesk.tecsinapse.com'
            target='_blank'
            rel='noreferrer'
          >
            ticket
          </a>
        </p>
      </div>
    </div>
  </div>
)

export default ServerMaintenance
